import { render, staticRenderFns } from "./EditAnalisisPenyelia.vue?vue&type=template&id=2f6f9924&scoped=true&"
import script from "./EditAnalisisPenyelia.vue?vue&type=script&lang=js&"
export * from "./EditAnalisisPenyelia.vue?vue&type=script&lang=js&"
import style0 from "./EditAnalisisPenyelia.vue?vue&type=style&index=0&id=2f6f9924&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f9924",
  null
  
)

export default component.exports